import { useEffect, useState } from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'
import ReviewForm from './ReviewForm'
import ReviewsCarousel from './ReviewsCarousel'

export default function ReviewsSection({ website, section, sectionFormStyling, useDefaultStyling = true, customerProfile = null, customerAuthToken = null }) {
  const [reviews, setReviews] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchReviews()
  }, [website])

  const fetchReviews = async () => {
    try {
      setLoading(true)
      const res = await axios.get(`/reviews/public/${website._id}`)
      setReviews(res.data.data || [])
    } catch (err) {
      console.error('Error fetching reviews:', err)
      toast.error('Failed to load reviews')
    } finally {
      setLoading(false)
    }
  }

  const handleReviewSubmit = () => {
    // Refresh reviews after a new review is submitted
    fetchReviews()
  }

  return (
    <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8 border-b border-gray-200 last:border-b-0">
      <div className="mb-12 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-2">{section.title || 'Customer Reviews'}</h2>
        {section.description && <p className="text-lg text-gray-600 max-w-2xl mx-auto">{section.description}</p>}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          {loading ? (
            <div className="text-center py-8">Loading reviews...</div>
          ) : reviews.length === 0 ? (
            <div className="text-center py-8 text-gray-500">No reviews yet</div>
          ) : (
            // Carousel ensures controlled sizing and clean presentation
            <div className="w-full min-h-[280px] sm:min-h-[340px] overflow-hidden">
              <ReviewsCarousel
                reviews={reviews}
                settings={{
                  autoPlay: reviews.length > 1,
                  interval: 8000,
                  transitionSpeed: 600,
                  showIndicators: reviews.length > 1,
                  showNavigation: reviews.length > 1
                }}
                onReviewSubmit={handleReviewSubmit}
              />
            </div>
          )}
        </div>

        <div>
          <div className="bg-white rounded-lg p-6 shadow">
            <h3 className="text-lg font-semibold mb-4">Leave a review</h3>
            <ReviewForm
              website={website}
              section={section}
              sectionFormStyling={sectionFormStyling}
              onReviewSubmit={handleReviewSubmit}
              useDefaultStyling={useDefaultStyling}
              sectionType="reviews"
              customerProfile={customerProfile}
              customerAuthToken={customerAuthToken}
            />
          </div>
        </div>
      </div>
    </div>
  )
}






// import { useEffect, useState } from 'react'
// import axios from 'axios'
// import toast from 'react-hot-toast'
// import ReviewForm from './ReviewForm'
// import ReviewsCarousel from './ReviewsCarousel'

// export default function ReviewsSection({ website, section, sectionFormStyling, useDefaultStyling = true }) {
//   const [reviews, setReviews] = useState([])
//   const [loading, setLoading] = useState(true)

//   useEffect(() => {
//     fetchReviews()
//   }, [website])

//   const fetchReviews = async () => {
//     try {
//       setLoading(true)
//       const res = await axios.get(`/reviews/public/${website._id}`)
//       setReviews(res.data.data || [])
//     } catch (err) {
//       console.error('Error fetching reviews:', err)
//       toast.error('Failed to load reviews')
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleReviewSubmit = () => {
//     // Refresh reviews after a new review is submitted
//     fetchReviews()
//   }

//   return (
//     <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8 border-b border-gray-200 last:border-b-0">
//       <div className="mb-12 text-center">
//         <h2 className="text-4xl font-bold text-gray-900 mb-2">{section.title || 'Customer Reviews'}</h2>
//         {section.description && <p className="text-lg text-gray-600 max-w-2xl mx-auto">{section.description}</p>}
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//         <div>
//           {loading ? (
//             <div className="text-center py-8">Loading reviews...</div>
//           ) : reviews.length === 0 ? (
//             <div className="text-center py-8 text-gray-500">No reviews yet</div>
//           ) : (
//             // Carousel ensures controlled sizing and clean presentation
//             <div className="w-full min-h-[260px]">
//               <ReviewsCarousel
//                 reviews={reviews}
//                 settings={{
//                   autoPlay: reviews.length > 1,
//                   interval: 8000,
//                   transitionSpeed: 600,
//                   showIndicators: reviews.length > 1,
//                   showNavigation: reviews.length > 1
//                 }}
//                 onReviewSubmit={handleReviewSubmit}
//               />
//             </div>
//           )}
//         </div>

//         <div>
//           <div className="bg-white rounded-lg p-6 shadow">
//             <h3 className="text-lg font-semibold mb-4">Leave a review</h3>
//             <ReviewForm website={website} section={section} sectionFormStyling={sectionFormStyling} onReviewSubmit={handleReviewSubmit} useDefaultStyling={useDefaultStyling} sectionType="reviews" />
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }
